<!--
 * @Author: your name
 * @Date: 2020-08-31 20:09:57
 * @LastEditTime: 2022-11-03 14:54:26
 * @LastEditors: 逐梦的风很轻 1114532270@qq.com
 * @Description: In User Settings Edit
 * @FilePath: /frontend-user/src/components/CountrySelect/index.vue
-->
<style lang="sass" scoped>
.option__image
  width: 25px
  height: 18px
.mobile__image
  margin-left: 5PX
</style>

<style lang="sass">
.navigation_multiselect
  width: 150PX

  .multiselect__single
    display: flex
    justify-content: center
    align-content: center
    margin-bottom: 0
    padding: 0
    max-height: 18PX
    min-height: 0
    line-height: 12PX
    align-items: center
    background-color: #F7F7F7
    width: 120PX

  .multiselect__tags
    padding-left: 0
    border: none
    border-bottom: 1px solid rgba(216,216,216,1)
    border-radius: 0

  // arrow
  // 箭头的样式
  .multiselect__select
    right: -8px

    &:before
      color: rgba(51, 68, 85, 0.5)

  .multiselect__option--highlight
    background: #1FC4BC !important

.multiselect__content-wrapper
  width: auto
  li span
    display: flex
    align-items: center

.multiselect__option
  padding: 21PX
  min-height: 0
  line-height: 10PX

.option_text
  font-size: 12PX !important
  margin-left: 8PX
  text-align: center

.country_text
  font-size: 12PX !important
  background-color: #F7F7F7
  padding-left: 10PX
  padding-right: 5PX
  text-align: center
  align-items: center
  width: 105PX
</style>

<template lang="pug">
multiselect.navigation_multiselect(
  :value="value",
  label="code",
  placeholder=""
  track-by="code",
  :options="countriesList",
  :option-height="104",
  :show-labels="false"
  :allow-empty="false"
  v-on="$listeners"
  @input="input"
)
  template(slot="singleLabel", slot-scope="props")
    img.option__image.mobile__image(:src="props.option.img")
    .country_text {{props.option.name}}
  template(slot="option", slot-scope="props")
    img.option__image(:src="props.option.img")
    .option_text {{props.option.name}}
</template>

<script>
// https://vue-multiselect.js.org/#sub-multiple-select
import Multiselect from 'vue-multiselect'
import 'vue-multiselect/dist/vue-multiselect.min.css'

// :option-height="104" -Height of custom option template   –自定义'选项模板'的高度。

export default {
  props: {
    value: {
      type: Object,
    },
    countriesList: Array
  },
  components: {
    Multiselect
  },
  methods: {
    input(val) {
      this.$emit('update:country', val)
    }
  }
}
</script>
